
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    isClickable: {
      type: Boolean,
      default: false,
    },
  },
});
